<template>
  <div class="rgg-data">
    <aside class="rgg-data__progress">
      <div class="rgg-progress">
        <h4 class="rgg-progress__title">Прогресс</h4>
        <ul class="rgg-progress-list">
          <li v-for="(platform, index) in platforms" :key="index" :class="[platform.statusClass, admin ? 'platform-admin' : '']"
              :title="gameCountTitle(platform)" class="rgg-progress-list__item" @click="editPlatform(platform)">
            <div class="platform-name">
              {{ platform.name }}
            </div>
            <div class="platform-game-count">
              <div :class="{'game-count-hidden' : platform.gameCount <= 1}"
                   class="game-count">+{{ platform.gameCount - 1 }}
              </div>
              <div :class="{'game-count-hidden' : platform.extraGameCount === 0}"
                   class="extra-game-count">
                +{{ platform.extraGameCount }}
              </div>
            </div>

          </li>
        </ul>
      </div>
    </aside>
    <div class="rgg-data__content">
      <div v-if="admin" class="rgg-admin">
        <button class="new-day" @click="newDay">Новый день</button>
        <button class="wheel" @click="wheel">Колесо</button>
        <button class="plus-game" @click="plusGameChanged('PlusGame')">+ Игра</button>
        <button class="minus-game" @click="plusGameChanged('MinusGame')">- Игра</button>
        <button class="plus-extra-game" @click="plusGameChanged('PlusExtraGame')">+ Экстра игра</button>
        <button class="minus-extra-game" @click="plusGameChanged('MinusExtraGame')">- Экстра игра</button>
        <button class="change-platform" @click="changePlatform">Смена плафтормы</button>
        <button class="add-item" @click="addItem">Предмет</button>
        <button class="queue" @click="queue">Очередь</button>
        <button class="other" @click="other">Другое</button>
      </div>
      <div class="rgg-current-game-layout">
        <div class="rgg-current-game">
          <div class="rgg-current-game__section rgg-current-game__section--title"><small
              class="rgg-current-game__caption">Текущая игра:</small>
            <h4 class="rgg-current-game__title">{{ gameInfo.name ?? 'Не выбрана' }} <sup
                v-if="gameInfo.platformName">{{ gameInfo.platformName }}</sup></h4>
          </div>
          <div class="rgg-current-game__section rgg-current-game__section--time">
            <small class="rgg-current-game__caption">Время прохождения:</small>
            <h4 class="rgg-current-game__title">{{ durationFormatted }}</h4>
          </div>
          <button v-if="admin" class="btn-transparent edit-game" title="Редактировать"
                  @click="editGame">
            <font-awesome-icon v-show="gameInfo.id" class="edit-icon" icon="fa-solid fa-pen"/>
          </button>
        </div>
        <div v-if="admin" class="rgg-current-game-admin">
          <button v-if="canRollGame" class="roll-game" @click="rollGame">Наролил</button>
          <button v-if="canStartGame" class="start-game" @click="startGame">Начал проходить</button>
          <button class="reroll-game" @click="rerollGame">Рерол</button>
          <button class="complete-game" @click="completeGame">Пройдено</button>
          <button class="drop-game" @click="dropGame">Дроп</button>
        </div>
      </div>
      <div class="rgg-content">
        <div class="rgg-content-tabs">
          <button :class="{'rgg-content-tabs__tab--active' : selectedTab === 'JournalTab' }"
                  class="rgg-content-tabs__tab" @click="selectedTab = 'JournalTab'">Журнал
          </button>
          <button :class="{'rgg-content-tabs__tab--active' : selectedTab === 'GamesTab' }"
                  class="rgg-content-tabs__tab" @click="selectedTab = 'GamesTab'">Список игр
          </button>
          <button :class="{'rgg-content-tabs__tab--active' : selectedTab === 'InventoryTab' }"
                  class="rgg-content-tabs__tab" @click="selectedTab = 'InventoryTab'">Инвентарь
          </button>
          <button :class="{'rgg-content-tabs__tab--active' : selectedTab === 'StatisticsTab' }"
                  class="rgg-content-tabs__tab" @click="selectedTab = 'StatisticsTab'">Статистика
          </button>
        </div>
        <div v-if="selectedTab === 'JournalTab'">
          <JournalList :journal-days="journalDays"
                       @edit-day="editDay"
                       @edit-journal-entry="editJournalEntry"
                       @cancel-last-event="cancelLastEvent"
                       @delete-queue-entry="deleteQueueEntry"/>
        </div>
        <div v-if="selectedTab === 'GamesTab'">
          <GameList :seasonNumber="seasonNumber"/>
        </div>
        <div v-if="selectedTab === 'InventoryTab'" class="rgg-content__block">
          <InventoryList :season-number="seasonNumber" :admin="admin" @item-used="loadJournalList(seasonNumber)" />
        </div>
        <div v-if="selectedTab === 'StatisticsTab'" class="rgg-content__block">
          <RggStatistics :season-number="seasonNumber" />
        </div>
      </div>
    </div>
  </div>
  <EditDayModal v-model:date="editDayRequestData.date"
                v-model:day="editDayRequestData.day"
                v-model:id="editDayRequestData.id"
                modal-id="edit-day-modal"
                @close="() => vfm.close('edit-day-modal')"
                @ok="editDayRequest"
  />
  <EditPlatformInfoModal v-model:wheelPrice="editPlatformRequestData.wheelPrice"
                v-model:platformName="editPlatformName"
                modal-id="edit-platform-modal"
                @close="() => vfm.close('edit-platform-modal')"
                @ok="editPlatformRequest"
  />
  <CancelLastEventModal modal-id="cancel-last-event-modal"
                        @close="() => vfm.close('cancel-last-event-modal')"
                        @ok="cancelLastEventRequest"
  />
  <DeleteQueueEntryModal modal-id="delete-queue-entry-modal"
                         @close="() => vfm.close('delete-queue-entry-modal')"
                         @ok="deleteQueueEntryRequest"
  />
  <EditJournalEntryModal v-model:entry-comment="editJournalEntryRequestData.comment"
                         v-model:entry-description="editJournalEntryRequestData.description"
                         :entry-event-type-name="selectedJournalEntry.eventTypeName"
                         modal-id="edit-journal-entry-modal"
                         @close="() => vfm.close('edit-journal-entry-modal')"
                         @ok="editJournalEntryRequest"
  />
  <NewJournalEntryModal v-model:entry-comment="newJournalEntryRequestData.comment"
                        v-model:entry-description="newJournalEntryRequestData.description"
                        :entry-event-type="newJournalEntryRequestData.eventType"
                        modal-id="new-journal-entry-modal"
                        @close="() => vfm.close('new-journal-entry-modal')"
                        @ok="newJournalEntryRequest"
  />
  <EditGameModal v-model:action-after-complete="gameActionAfterComplete"
                 v-model:action-after-drop="gameActionAfterDrop"
                 v-model:game-blind="editGameData.blind"
                 v-model:game-comment="editGameData.comment"
                 v-model:game-difficulty="editGameData.difficulty"
                 v-model:game-duration="editGameData.duration"
                 v-model:game-first-playthrough="editGameData.firstPlaythrough"
                 v-model:game-genre-id="editGameData.genreId"
                 v-model:game-name="editGameData.name"
                 v-model:game-platform-id="editGameData.platformId"
                 v-model:game-rage-meter="editGameData.rageMeter"
                 v-model:game-rate="editGameData.rate"
                 v-model:game-region="editGameData.region"
                 :game-blind-items="gameBlindItems"
                 :game-edit-mode="gameEditMode"
                 :game-first-playthrough-items="gameFirstPlaythroughItems"
                 :game-genres="gameGenres"
                 :game-id="editGameData.id"
                 :game-platforms="gamePlatforms"
                 :game-regions="gameRegions"
                 :game-status="gameStatus"
                 modal-id="edit-game-modal"
                 @close="() => vfm.close('edit-game-modal')"
                 @ok="gameActionRequest"
  />
  <WheelModal v-model:wheel-comment="wheelData.comment"
              v-model:wheel-item-id="wheelData.itemId"
              v-model:wheel-price="wheelData.price"
              :wheel-items="wheelItems"
              :wheel-prices="wheelPrices"
              modal-id="wheel-modal"
              @close="() => vfm.close('wheel-modal')"
              @ok="wheelRequest"
  />
  <PlusGameChangedModal v-model:comment="gameCountData.comment"
                        v-model:game-count="gameCountData.gameCount"
                        v-model:rgg-platform-id="gameCountData.rggPlatformId"
                        :operation-type="gameCountData.operationType"
                        :rgg-platforms="platforms"
                        modal-id="plus-game-changed-modal"
                        @close="() => vfm.close('plus-game-changed-modal')"
                        @ok="plusGameChangedRequest"
  />
  <ChangePlatformModal v-model:comment="changePlatformData.comment"
                       v-model:rgg-platform-id="changePlatformData.rggPlatformId"
                       :rgg-platforms="platforms"
                       modal-id="change-platform-modal"
                       @close="() => vfm.close('change-platform-modal')"
                       @ok="changePlatformRequest"
  />
  <ItemModal v-model:action="itemData.actionType"
             v-model:comment="itemData.comment"
             v-model:item-id="itemData.itemId"
             :items="items"
             modal-id="item-modal"
             @close="() => vfm.close('item-modal')"
             @ok="itemRequest"
  />
</template>

<script>
import ApiService from "@/services/api-service";
import {useVfm} from "vue-final-modal";
import moment from "moment";
import JournalList from "@/components/JournalList";
import EditDayModal from "@/components/EditDayModal";
import CancelLastEventModal from "@/components/CancelLastEventModal";
import EditGameModal from "@/components/EditGameModal";
import EditPlatformInfoModal from "@/components/EditPlatformInfoModal.vue";
import EditJournalEntryModal from "@/components/EditJournalEntryModal";
import WheelModal from "@/components/WheelModal";
import PlusGameChangedModal from "@/components/PlusGameChangedModal";
import ChangePlatformModal from "@/components/ChangePlatformModal";
import ItemModal from "@/components/ItemModal";
import NewJournalEntryModal from "@/components/NewJournalEntryModal";
import DeleteQueueEntryModal from "@/components/DeleteQueueEntryModal";
import GameList from "@/components/GameList";
import InventoryList from "@/components/InventoryList";
import RggStatistics from "@/components/RggStatistics";

export default {
  name: "RggSeason",
  data: function () {
    return {
      vfm: null,
      selectedTab: "JournalTab",
      platforms: [],
      journalDays: [],
      gameList: [],
      inventoryItems: [],
      gamePlatforms: [],
      gameGenres: [],
      gameRegions: [],
      gameFirstPlaythroughItems: [],
      gameBlindItems: [],
      wheelItems: [],
      items: [],
      wheelPrices: [],
      gameStatus: null,
      gameEditMode: false,
      gameActionAfterComplete: "NormalGame",
      gameActionAfterDrop: "Return",
      gameInfo: {
        id: null,
        name: null,
        status: null,
        platformId: null,
        platformName: null,
        genreId: null,
        region: null,
        duration: null
      },
      selectedQueueEntryId: null,
      selectedJournalEntry: {
        id: null,
        platformName: null,
        gameCount: null,
        extraGameCount: null,
        eventType: null,
        eventTypeName: null,
        description: null,
        comment: null,
        lastRecord: false
      },
      editDayRequestData: {
        id: null,
        day: null,
        date: null
      },
      editPlatformName: null,
      editPlatformRequestData: {
        id: null,
        wheelPrice: null
      },
      editJournalEntryRequestData: {
        id: null,
        eventTypeId: null,
        description: null,
        comment: null
      },
      newJournalEntryRequestData: {
        eventType: null,
        description: null,
        comment: null
      },
      editGameData: {
        id: null,
        name: null,
        platformId: null,
        genreId: null,
        region: null,
        duration: null,
        rate: null,
        difficulty: null,
        rageMeter: null,
        firstPlaythrough: null,
        blind: null,
        comment: null
      },
      wheelData: {
        itemId: null,
        price: null,
        comment: null
      },
      itemData: {
        itemId: null,
        actionType: null,
        comment: null
      },
      gameCountData: {
        operationType: null,
        rggPlatformId: null,
        gameCount: null,
        comment: null
      },
      changePlatformData: {
        rggPlatformId: null,
        comment: null
      }
    }
  },
  components: {
    RggStatistics,
    InventoryList,
    DeleteQueueEntryModal,
    NewJournalEntryModal,
    ChangePlatformModal,
    PlusGameChangedModal,
    WheelModal,
    EditJournalEntryModal,
    EditGameModal,
    CancelLastEventModal,
    JournalList,
    GameList,
    EditDayModal,
    EditPlatformInfoModal,
    ItemModal
  },
  props: ["seasonNumber"],
  computed: {
    admin: function () {
      return localStorage.getItem("token") !== null
    },
    today: function () {
      return moment().toISOString(true).split('T')[0]
    },
    canRollGame: function () {
      return !this.gameInfo.id
    },
    canStartGame: function () {
      return !this.gameInfo.id || (this.gameInfo.id && this.gameInfo.status === 'Rolled')
    },
    durationFormatted: function () {
      if (!this.gameInfo.duration) {
        return "00:00:00"
      }

      let totalSeconds = this.gameInfo.duration
      let hours = Math.floor(totalSeconds / 3600)
      let minutes = Math.floor(totalSeconds / 60) - hours * 60
      let seconds = totalSeconds % 60

      return `${hours.pad(2)}:${minutes.pad(2)}:${seconds.pad(2)}`
    }
  },
  methods: {
    getPlatformStatusClass(platformStatus) {
      if (platformStatus === "InProgress") {
        return "rgg-progress-list__item--current"
      }

      if (platformStatus === "Completed") {
        return "rgg-progress-list__item--done"
      }

      if (platformStatus === "Waiting") {
        return ""
      }
    },
    gameCountTitle(platform) {
      if (platform.gameCount > 1 || platform.extraGameCount > 0) {
        return `Штрафных: ${platform.gameCount - 1}; Экстра: ${platform.extraGameCount}`
      }

      return "Нет дополнительных игр"
    },
    loadData(seasonNumber) {
      this.loadGameInfo(seasonNumber)
      this.loadPlatforms(seasonNumber)
      this.loadJournalList(seasonNumber)

      ApiService.get(`rgg/items/season/${this.seasonNumber}/wheel-items`).then(response => {
        this.wheelItems = response.data
      })

      ApiService.get(`rgg/items/season/${this.seasonNumber}/items`).then(response => {
        this.items = response.data
      })
    },
    loadGameInfo(seasonNumber) {
      ApiService.get(`rgg/season/${seasonNumber}/game-info`).then(response => {
        this.gameInfo = response.data

        this.editGameData.id = this.gameInfo.id
        this.editGameData.name = this.gameInfo.name
        this.editGameData.platformId = this.gameInfo.platformId
        this.editGameData.genreId = this.gameInfo.genreId
        this.editGameData.region = this.gameInfo.region
        this.editGameData.duration = this.gameInfo.duration
      })
    },
    loadPlatforms(seasonNumber) {
      ApiService.get(`rgg/season/${seasonNumber}/platforms`).then(response => {
        this.platforms = response.data.map(platform => {
          platform.statusClass = this.getPlatformStatusClass(platform.status)
          return platform
        })
      })
    },
    loadJournalList(seasonNumber) {
      ApiService.put(`rgg/journal/list`, {
        seasonNumber: seasonNumber
      }).then(response => {
        this.journalDays = response.data.map(day => {
          day.dayFormatted = moment(day.date).format("L")
          return day
        })
      })
    },
    newDay() {
      this.editDayRequestData = {
        id: null,
        day: null,
        date: this.today
      }
      this.vfm.open('edit-day-modal')
    },
    editDay(day) {
      this.editDayRequestData = {
        id: day.id,
        day: day.day,
        date: day.date
      }
      this.vfm.open('edit-day-modal')
    },
    editPlatform(platform) {
      if (!this.admin){
        return
      }

      this.editPlatformName = platform.shortName
      this.editPlatformRequestData = {
        id: platform.id,
        wheelPrice: platform.wheelPrice
      }
      this.vfm.open('edit-platform-modal')
    },
    editJournalEntry(entry) {
      this.selectedJournalEntry = entry
      this.editJournalEntryRequestData = {
        id: entry.id,
        description: entry.description,
        comment: entry.comment
      }
      this.vfm.open('edit-journal-entry-modal')
    },
    cancelLastEvent() {
      this.vfm.open('cancel-last-event-modal')
    },
    deleteQueueEntry(entry) {
      this.selectedQueueEntryId = entry.id
      this.vfm.open('delete-queue-entry-modal')
    },
    rollGame() {
      this.gameStatus = "Rolled"
      this.gameEditMode = false

      this.editGameData = {
        id: null,
        name: null,
        platformId: null,
        genreId: null,
        region: null,
        duration: null,
        rate: null,
        difficulty: null,
        rageMeter: null,
        firstPlaythrough: null,
        blind: null,
        comment: null
      }

      this.vfm.open('edit-game-modal')
    },
    startGame() {
      this.gameStatus = "Started"
      this.gameEditMode = false

      this.editGameData.duration = null
      this.editGameData.rate = null
      this.editGameData.difficulty = null
      this.editGameData.rageMeter = null
      this.editGameData.firstPlaythrough = null
      this.editGameData.blind = null
      this.editGameData.comment = null

      if (this.gameInfo.id && this.gameInfo.status === "Rolled") {
        this.gameActionRequest()
      } else if (!this.gameInfo.id) {
        this.vfm.open('edit-game-modal')
      }
    },
    rerollGame() {
      this.gameStatus = "Reroll"
      this.gameEditMode = false

      this.editGameData.rate = null
      this.editGameData.difficulty = null
      this.editGameData.rageMeter = null
      this.editGameData.firstPlaythrough = null
      this.editGameData.blind = null
      this.editGameData.comment = null

      this.vfm.open('edit-game-modal')
    },
    completeGame() {
      this.gameStatus = "Completed"
      this.gameEditMode = false

      this.editGameData.rate = null
      this.editGameData.difficulty = null
      this.editGameData.rageMeter = null
      this.editGameData.firstPlaythrough = null
      this.editGameData.blind = null
      this.editGameData.comment = null

      this.vfm.open('edit-game-modal')
    },
    dropGame() {
      this.gameStatus = "Dropped"
      this.gameEditMode = false

      this.editGameData.rate = null
      this.editGameData.difficulty = null
      this.editGameData.rageMeter = null
      this.editGameData.firstPlaythrough = null
      this.editGameData.blind = null
      this.editGameData.comment = null

      this.vfm.open('edit-game-modal')
    },
    editGame() {
      this.gameStatus = this.gameInfo.status
      this.gameEditMode = true

      this.editGameData.id = this.gameInfo.id
      this.editGameData.name = this.gameInfo.name
      this.editGameData.platformId = this.gameInfo.platformId
      this.editGameData.genreId = this.gameInfo.genreId
      this.editGameData.region = this.gameInfo.region
      this.editGameData.duration = this.gameInfo.duration

      this.vfm.open('edit-game-modal')
    },
    wheel() {
      this.wheelData = {
        itemId: null,
        price: null,
        comment: null
      }
      this.vfm.open('wheel-modal')
    },
    addItem() {
      this.itemData = {
        itemId: null,
        actionType: null,
        comment: null
      }
      this.vfm.open('item-modal')
    },
    plusGameChanged(operationType) {
      let activePlatform = this.platforms.find(item => item.status === "InProgress")

      this.gameCountData = {
        operationType: operationType,
        rggPlatformId: activePlatform.id,
        gameCount: 1,
        comment: null
      }
      this.vfm.open('plus-game-changed-modal')
    },
    changePlatform() {
      this.changePlatformData = {
        rggPlatformId: null,
        comment: null
      }

      this.vfm.open('change-platform-modal')
    },
    queue() {
      this.newJournalEntryRequestData = {
        eventType: "Queue",
        description: null,
        comment: null
      }
      this.vfm.open('new-journal-entry-modal')
    },
    other() {
      this.newJournalEntryRequestData = {
        eventType: "Other",
        description: null,
        comment: null
      }
      this.vfm.open('new-journal-entry-modal')
    },
    editDayRequest() {
      ApiService.post("rgg/journal/save-day", {
        seasonNumber: this.seasonNumber,
        id: this.editDayRequestData.id,
        date: this.editDayRequestData.date
      }).then(() => {
        this.vfm.close('edit-day-modal')
        this.loadJournalList(this.seasonNumber)
      })
    },
    editPlatformRequest() {
      ApiService.post("rgg/journal/edit-platform-info", {
        seasonNumber: this.seasonNumber,
        id: this.editPlatformRequestData.id,
        wheelPrice: this.editPlatformRequestData.wheelPrice
      }).then(() => {
        this.vfm.close('edit-platform-modal')
        this.loadPlatforms(this.seasonNumber)
      })
    },
    editJournalEntryRequest() {
      ApiService.put(`rgg/journal/edit-event`, this.editJournalEntryRequestData).then(() => {
        this.vfm.close('edit-journal-entry-modal')
        this.loadJournalList(this.seasonNumber)
      })
    },
    newJournalEntryRequest() {
      ApiService.put(`rgg/journal/new-event`, {
        seasonNumber: this.seasonNumber,
        model: this.newJournalEntryRequestData
      }).then(() => {
        this.vfm.close('new-journal-entry-modal')
        this.loadJournalList(this.seasonNumber)
      })
    },
    cancelLastEventRequest() {
      ApiService.delete(`rgg/journal/cancel-last-event?seasonNumber=${this.seasonNumber}`).then(() => {
        this.vfm.close('cancel-last-event-modal')
        this.loadGameInfo(this.seasonNumber)
        this.loadPlatforms(this.seasonNumber)
        this.loadJournalList(this.seasonNumber)
      })
    },
    deleteQueueEntryRequest() {
      ApiService.delete(`rgg/journal/delete-queue-entry/${this.selectedQueueEntryId}`).then(() => {
        this.vfm.close('delete-queue-entry-modal')
        this.loadJournalList(this.seasonNumber)
      })
    },
    gameActionRequest() {
      ApiService.post("rgg/journal/game-action", {
        seasonNumber: this.seasonNumber,
        status: this.gameStatus,
        gameModel: this.editGameData,
        editMode: this.gameEditMode,
        actionAfterComplete: this.gameActionAfterComplete,
        actionAfterDrop: this.gameActionAfterDrop
      }).then(() => {
        this.vfm.close('edit-game-modal')
        this.loadGameInfo(this.seasonNumber)
        this.loadPlatforms(this.seasonNumber)
        this.loadJournalList(this.seasonNumber)
      })
    },
    wheelRequest() {
      ApiService.post("rgg/journal/wheel", {
        seasonNumber: this.seasonNumber,
        wheelModel: this.wheelData
      }).then(() => {
        this.vfm.close('wheel-modal')
        this.loadJournalList(this.seasonNumber)
      })
    },
    itemRequest() {
      ApiService.post("rgg/journal/item", {
        seasonNumber: this.seasonNumber,
        itemModel: this.itemData
      }).then(() => {
        this.vfm.close('item-modal')
        this.loadJournalList(this.seasonNumber)
      })
    },
    plusGameChangedRequest() {
      ApiService.post("rgg/journal/plus-game-changed", {
        seasonNumber: this.seasonNumber,
        model: this.gameCountData
      }).then(() => {
        this.vfm.close('plus-game-changed-modal')
        this.loadPlatforms(this.seasonNumber)
        this.loadJournalList(this.seasonNumber)
      })
    },
    changePlatformRequest() {
      ApiService.post("rgg/journal/change-platform", {
        seasonNumber: this.seasonNumber,
        model: this.changePlatformData
      }).then(() => {
        this.vfm.close('change-platform-modal')
        this.loadPlatforms(this.seasonNumber)
        this.loadJournalList(this.seasonNumber)
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.selectedTab = 'JournalTab'
    this.loadData(to.params.seasonNumber)
    next()
  },
  created() {
    this.vfm = useVfm()
    this.loadData(this.seasonNumber)

    ApiService.get("items/platforms").then(response => {
      this.gamePlatforms = response.data
    })

    ApiService.get("items/genres").then(response => {
      this.gameGenres = response.data
    })

    ApiService.get("items/regions").then(response => {
      this.gameRegions = response.data
    })

    ApiService.get("items/first-playthrough").then(response => {
      this.gameFirstPlaythroughItems = response.data
    })

    ApiService.get("items/blind").then(response => {
      this.gameBlindItems = response.data
    })

    ApiService.get("rgg/items/wheel-prices").then(response => {
      this.wheelPrices = response.data
    })
  }
}
</script>

<style scoped>
.new-day {
  border-color: #3db03d;
  background-color: #058d05;
}

.new-day:hover {
  border-color: #1d801d;
  background-color: #067006;
}

.wheel {
  border-color: #ffa143;
  background-color: #d96c00;
}

.wheel:hover {
  border-color: #ff8103;
  background-color: #bb5d00;
}

.plus-game {
  border-color: #f70000;
  background-color: #b90000;
}

.plus-game:hover {
  border-color: #bb0a0a;
  background-color: #950202;
}

.minus-game {
  border-color: #0d9bff;
  background-color: #0385c3;
}

.minus-game:hover {
  border-color: #077dcf;
  background-color: #00689b;
}

.plus-extra-game {
  border-color: #9801ff;
  background-color: #6d00b8;
}

.plus-extra-game:hover {
  border-color: #7000bd;
  background-color: #4a007c;
}

.minus-extra-game {
  border-color: #1ec19b;
  background-color: #019b8c;
}

.minus-extra-game:hover {
  border-color: #069171;
  background-color: #0c746b;
}

.change-platform {
  border-color: #394eff;
  background-color: #0118d6;
}

.change-platform:hover {
  border-color: #1932ff;
  background-color: #01129d;
}

.add-item {
  border-color: #9801ff;
  background-color: #6d00b8;
  /*border-color: #b8a21d;
  background-color: #8d7c13;*/
}

.add-item:hover {
  border-color: #7000bd;
  background-color: #4a007c;
  /*border-color: #907d0d;
  background-color: #7c6c0a;*/
}

.queue {
  border-color: #8b8b8b;
  background-color: #6a6a6a;
}

.queue:hover {
  border-color: #686868;
  background-color: #484848;
}

.other {
  border-color: #1ec19b;
  background-color: #019b8c;
}

.other:hover {
  border-color: #069171;
  background-color: #0c746b;
}

.edit-game {
  align-self: start;
  margin-left: 24px;
}

.edit-icon {
  color: var(--edit-icon-color);
}

.roll-game {
  border-color: #0d9bff;
  background-color: #0385c3;
}

.roll-game:hover {
  border-color: #077dcf;
  background-color: #00689b;
}

.start-game {
  border-color: #1ec19b;
  background-color: #019b8c;
}

.start-game:hover {
  border-color: #069171;
  background-color: #0c746b;
}

.reroll-game {
  border-color: #8b8b8b;
  background-color: #6a6a6a;
}

.reroll-game:hover {
  border-color: #686868;
  background-color: #484848;
}

.complete-game {
  border-color: #248b17;
  background-color: #006600;
}

.complete-game:hover {
  border-color: #0b6800;
  background-color: #015401;
}

.drop-game {
  border-color: #f70000;
  background-color: #b90000;
}

.drop-game:hover {
  border-color: #bb0a0a;
  background-color: #950202;
}

.platform-admin{
  cursor: pointer;
}
</style>